import { CoreBox } from '@vitvio/design-system';
import { InfoBoxItem } from './InfoBoxItem';
import type { JobCardContent } from '../../types';

interface InfoBoxProps {
  data: JobCardContent;
  isTurnover?: boolean;
}

export function InfoBox({
  data: {
    status,
    scheduleStatus,
    plannedStart,
    plannedStop,
    estimatedStartTime,
    estimatedStopTime,
    actualStartTime,
    actualStopTime,
    durations,
    lastEvent,
    estimateSource,
  },
  isTurnover,
}: InfoBoxProps) {
  const isJobUnclosed = estimateSource === 'SYSTEM';
  const isHidden = !isTurnover && status === 'COMPLETED';

  return (
    <CoreBox
      flexColumn
      bg="card.bg.emphasized.infobox"
      borderRadius="md"
      m="0.5"
      p="1.5"
      gap="1.5"
      hidden={isHidden}
      groupHoverDisplay="flex"
    >
      {!isTurnover && (
        <>
          <InfoBoxItem
            type="time"
            status={status}
            scheduleStatus={scheduleStatus}
            position="start"
            plannedTime={plannedStart}
            actualTime={actualStartTime}
            estimatedTime={estimatedStartTime}
          />
          <InfoBoxItem
            type="time"
            status={status}
            scheduleStatus={scheduleStatus}
            position="end"
            plannedTime={plannedStop}
            actualTime={actualStopTime}
            estimatedTime={estimatedStopTime}
            isJobUnclosed={isJobUnclosed}
          />
        </>
      )}
      <InfoBoxItem
        type="duration"
        duration={durations?.dynamicDurationMinutes ?? 0}
        plannedDuration={durations?.plannedDurationMinutes ?? 0}
        isTurnover={isTurnover}
      />
      {!isTurnover && lastEvent && <InfoBoxItem type="lastEvent" lastEvent={lastEvent} />}
    </CoreBox>
  );
}
